import { from, map, Observable, switchMap } from 'rxjs';
import { MediaDeviceFinder } from './MediaDeviceFinder';

export class VideoMediaDeviceFinder implements MediaDeviceFinder {
  public getAvailableMediaInfos(): Observable<MediaDeviceInfo[]> {
    return this.requestCameraPermission().pipe(
      switchMap(() => navigator.mediaDevices.enumerateDevices()),
      map((mediaDeviceInfos) => mediaDeviceInfos.filter((m) => m.kind === 'videoinput'))
    );
  }

  public getMediaStreamForDeviceWithId(id: string): Observable<MediaStream> {
    return from(navigator.mediaDevices.getUserMedia({ video: { deviceId: id } }));
  }

  private requestCameraPermission(): Observable<MediaStream> {
    return from(navigator.mediaDevices.getUserMedia({ video: true }));
  }
}
